import React from 'react'

export const useActiveCategory = () => {
  const [output, setOutput] = React.useState(null)

  const hasOutput = output != null

  const handleOutputChange = React.useCallback(
    category => () => {
      setOutput(category)
    },
    [setOutput],
  )

  const handleReset = React.useCallback(() => {
    setOutput(null)
  }, [setOutput])

  return {
    output,
    handleOutputChange,
    handleReset,
    hasOutput,
  }
}
